export default {
  path: 'temporary-regulations/requests/:id',
  name: 'TemporaryRegulationsRequestDetails',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/RequestDetails.vue')
}
